module.exports = __webpack_public_path__ + "img/after-decline.4c842f02.svg";